"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Button = _interopRequireDefault(require("../Button"));

var _Image = _interopRequireDefault(require("../Image"));

var _Text = _interopRequireDefault(require("../Text"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _constant = require("../JourneyPriceCTA/constant");

var _UnavailableNoticeBlock = _interopRequireDefault(require("./UnavailableNoticeBlock.proptypes"));

var _constant2 = require("./constant");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var ContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "UnavailableNoticeBlock__ContentWrapper",
  componentId: "sc-11h611u-0"
})(["display:flex;flex-direction:column;align-items:center;gap:", ";width:17.5rem;"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.small;
});

var TextWrapper = _styledComponents.default.div.withConfig({
  displayName: "UnavailableNoticeBlock__TextWrapper",
  componentId: "sc-11h611u-1"
})(["display:flex;flex-direction:column;gap:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.micro;
});

var ButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "UnavailableNoticeBlock__ButtonContainer",
  componentId: "sc-11h611u-2"
})(["display:flex;flex-direction:column;gap:", ";width:100%;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.tiny;
});

var UnavailableNoticeBlock = function UnavailableNoticeBlock(_ref4) {
  var theme = _ref4.theme,
      translation = _ref4.translation,
      switchToEconomyCta = _ref4.switchToEconomyCta,
      searchAnotherDateCta = _ref4.searchAnotherDateCta;

  var translations = _objectSpread(_objectSpread({}, _constant2.TRANSLATIONS), translation);

  var isMoveTheme = theme === _constant.THEMES.MOVE;
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(ContentWrapper, null, /*#__PURE__*/_react.default.createElement(_Image.default, {
    src: _constant2.UNAVAILABLE_IMG_URL,
    alt: _constant2.IMAGE_NOT_FOUND,
    width: _constant2.IMAGE.width,
    height: _constant2.IMAGE.height,
    placeHolderBackground: _constant2.COLOR.neutral
  }), /*#__PURE__*/_react.default.createElement(TextWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "titleSmall",
    bold: true,
    textAlign: _constant2.ALIGN.center,
    display: "block"
  }, translations.soldoutTitle), /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "textSmall",
    color: _constant2.COLOR.greyDark,
    textAlign: _constant2.ALIGN.center,
    display: "block"
  }, translations.soldoutSubtitle)), /*#__PURE__*/_react.default.createElement(ButtonContainer, null, switchToEconomyCta && /*#__PURE__*/_react.default.createElement(_Button.default, {
    accessible: true,
    backgroundColor: "default",
    boxShadow: true,
    buttonType: "button",
    cardIndex: 0,
    color: _constant.moveSecondaryButton[isMoveTheme].color,
    handleClick: switchToEconomyCta,
    hoverColor: _constant.moveSecondaryButton[isMoveTheme].color,
    size: "normal",
    theme: theme,
    type: "normal",
    border: _constant.moveSecondaryButton[isMoveTheme].border
  }, translations.soldoutEconomyCta), searchAnotherDateCta && /*#__PURE__*/_react.default.createElement(_Button.default, {
    accessible: true,
    backgroundColor: "primary",
    boxShadow: true,
    buttonType: "button",
    cardIndex: 0,
    color: _constant.movePrimaryButton[isMoveTheme].color,
    defaultDisabledFeatures: false,
    handleClick: searchAnotherDateCta,
    hoverBackgroundColor: "primary",
    hoverColor: _constant.movePrimaryButton[isMoveTheme].color,
    size: "normal",
    theme: theme,
    type: "normal",
    border: _constant.movePrimaryButton[isMoveTheme].border
  }, translations.soldoutSearchCta))));
};

UnavailableNoticeBlock.propTypes = _UnavailableNoticeBlock.default.PropTypes;
UnavailableNoticeBlock.defaultProps = _UnavailableNoticeBlock.default.defaultProps;
var _default = UnavailableNoticeBlock;
exports.default = _default;